import React, { useCallback, useContext } from "react";
import { ModalContext } from "src/modules/Modal";
import { SearchParams } from "src/services";
import { useCreatePWSSubmissionPeriodExportMutation } from "src/services/export-service-api";
import { ExportType } from "src/types/enums/ExportRequest";
import { displayDownloadStarted, toastError } from "src/utils/toast";
import ExportDropdown from "src/modules/Exports/ExportDropdown";
import { SubmissionPeriodType } from "src/types/enums/SubmissionPeriodType";

interface ExportOptionDropdownProps {
  submissionPeriodId: number;
  submissionPeriodType: SubmissionPeriodType;
  params: SearchParams;
  options: Array<{ key: string; text: string; value: ExportType }>;
}

const Exporter: React.FC<ExportOptionDropdownProps> = ({
  submissionPeriodId,
  submissionPeriodType,
  params,
  options
}) => {
  const { openModal, closeModal } = useContext(ModalContext);
  const [exportSubmissions] = useCreatePWSSubmissionPeriodExportMutation();

  const handleExport = useCallback((exportType: ExportType): void => {
    if (exportType === ExportType.PWSSubmissionPeriod) {
      exportSubmissions({ params, submissionPeriodId, submissionPeriodType }).catch(() => toastError('Unable to generate export.'))
      displayDownloadStarted({ type: 'export' })
    } else {
      openModal("exportModal", {
        exportType,
        submissionPeriodId,
        closeModal,
        params
      });
    }
  }, [params, submissionPeriodId, submissionPeriodType, exportSubmissions, openModal, closeModal]);

  return (
    <ExportDropdown handleExport={handleExport} exportOptions={options} />
  );
};

export default Exporter;
